<template>
  <el-form-item class="app-form-composite-item" :label="computedLabel" style="margin-bottom:0px">
    <div class="el-form--inline">
      <slot name="default"></slot>
    </div>
  </el-form-item>
</template>

<script>
/* eslint-disable semi */
import { Component, Prop } from 'vue-property-decorator';
import AppComponent from '@/app/AppComponent';

@Component
export default class AppFormCompositItem extends AppComponent {
  @Prop({ required: false, default: null })
  label;

  data () {
    return {
      innerLabel: null
    }
  }

  /**
   * プロパティで指定されたラベルを優先する
   */
  get computedLabel () {
    if (this.label != null) {
      return this.label;
    } else {
      return this.innerLabel;
    }
  }

  /**
   * マウントされたタイミングで配下のFormItemからラベルを取得する
   */
  mounted () {
    if (this.label != null) {
      return;
    }

    // 配下のFormItemの先頭項目のラベルを取得する
    if (this.$children && this.$children[0].$children) {
      this.$children[0].$children.forEach(element => {
        const label = element.computedLabel;
        if (label === null || label === undefined) {
          return;
        }
        // カッコ記述（FROM）（TO）は除去する
        // カッコ記述がない場合、開始日・月・年という文言で終了する場合は期間に置換する
        if (this.innerLabel == null) {
          if (label.match(/[\\(（].*[）\\)]/)) {
            this.innerLabel = label
              .replace(/[\\(（].*[）\\)]/, '');
          } else {
            this.innerLabel = label
              .replace(/開始[日月年]$/, '期間');
          }
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/AppFormCompositeItem.vue